// extracted by mini-css-extract-plugin
module.exports = {"noResult":"NoResult_noResult__YXYkH"};